import { render, staticRenderFns } from "./monitors.page.vue?vue&type=template&id=ba899e46&scoped=true"
import script from "./monitors.page.vue?vue&type=script&lang=js"
export * from "./monitors.page.vue?vue&type=script&lang=js"
import style0 from "./monitors.page.vue?vue&type=style&index=0&id=ba899e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba899e46",
  null
  
)

export default component.exports